// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"363d7e04","485":"149e9bb2","746":"9b4c6fcc","941":"5e6f2f1c"}[chunkId] + ".chunk.css";
};